module.exports = __webpack_public_path__ + "img/daragh.0a12f80.webp";